import { useState } from "react";

export const useVehicleViewModals = () => {
    const [openFuelAddModal, setOpenFuelAddModal] = useState(false);
    const [openMeterAddModal, setOpenMeterAddModal] = useState(false);
    const [openRenewalAddModal, setOpenRenewalAddModal] = useState(false);
    const [openIncidentAddModal, setOpenIncidentAddModal] = useState(false);
    const [openExpenseAddModal, setOpenExpenseAddModal] = useState(false);
    const [openServicesAddModal, setOpenServicesAddModal] = useState(false);
    const [openServiceConfigAddModal, setOpenServiceConfigAddModal] = useState(false);

    const handleOpenAddModal = (activeTab, handleAddMediaClick) => {
        switch (activeTab) {
            case "Fuels":
                setOpenFuelAddModal(true);
                break;
            case "Meters":
                setOpenMeterAddModal(true);
                break;
            case "Services":
                setOpenServicesAddModal(true);
                break;
            case "Renewals":
                setOpenRenewalAddModal(true);
                break;
            case "Incidents":
                setOpenIncidentAddModal(true);
                break;
            case "Expenses":
                setOpenExpenseAddModal(true);
                break;
            case "Media":
                handleAddMediaClick();
                break;
            case "ServiceConfig":
                setOpenServiceConfigAddModal(true);
                break;
            default:
                break;
        }
    };

    const handleCloseAddModal = () => {
        setOpenFuelAddModal(false);
        setOpenMeterAddModal(false);
        setOpenRenewalAddModal(false);
        setOpenIncidentAddModal(false);
        setOpenExpenseAddModal(false);
        setOpenServicesAddModal(false);
        setOpenServiceConfigAddModal(false);
    };

    const handleAddItem = (newItem, setNewlyAddedItem) => {
        setNewlyAddedItem(newItem);
    };

    const handleOpenEditModal = (item, setNewlyAddedItem) => {
        setNewlyAddedItem(item);
    };

    return {
        openFuelAddModal,
        openMeterAddModal,
        openRenewalAddModal,
        openIncidentAddModal,
        openExpenseAddModal,
        openServicesAddModal,
        openServiceConfigAddModal,
        setOpenServiceConfigAddModal,
        handleOpenAddModal,
        handleCloseAddModal,
        handleAddItem,
        handleOpenEditModal,

    };
}; 